import { TEMP_PREFIX } from '../Models.constants';

export const isTempEntity = (entityId: string) => {
  return entityId.startsWith(TEMP_PREFIX);
};
